import React, { useEffect } from "react";
import Header from "../components/Frontend/Header";
import Footer from "../components/Frontend/Footer";
import { getEmail, getAddress } from "utils/contactInfo";
import ReactGA from "react-ga";
import { EFFECTIVE_DATE } from "constants/policyDate";
import HeroSectionUpdatedSecond from "components/PublicPagesReusable/HeroSectionUpdatedSecond";
import CtaBanner from "components/PublicPagesReusable/CtaBanner";
import NocBanner from "components/PublicPagesReusable/NocBanner";
import { Helmet } from "react-helmet";

const Refund = () => {
  useEffect(() => {
    ReactGA.initialize("UA-157984080-1");
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);

  const heroWorkTitle = () => {
    return (
      <h1 className="FS48 fw-500 top-section-text">  
          <span className="text-success">Refund </span>Policy
      </h1>
    );
  };

  const heroData = {
    badge: "Australia’s Leading English Proficiency Centre",
    title: heroWorkTitle,
    subtitle: `Language Academy Australia Pty Ltd <br/> Effective Date: ${EFFECTIVE_DATE}`,
    
    users: [
      
    ],
    trustText: "",
    
    bottomStatsText: [
      { value: "8",highlight:'+', label: "Years of NAATI Expertise" },
      { value: "50k", highlight:'+', label: "Students' Helped" },
      { value: "10", highlight:'+', label: "Global Locations" },
      { value: "95", highlight:'%', label: "Success Rate" }
    ]
  };

  return (
    <React.Fragment>
      <Helmet>
        <title>Refund Policy | LA Language Academy Australia</title>
        <meta name="description" content="Understand LA Language Academy's refund policies for all courses and services. Learn about our transparent and hassle-free refund process." />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://www.languageacademy.com.au/refund-policies" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@languageacademy" />
        <meta name="twitter:title" content="Refund Policy | LA Language Academy Australia" />
        <meta name="twitter:description" content="Understand LA Language Academy's refund policies for all courses and services. Learn about our transparent and hassle-free refund process." />
        <meta name="twitter:image" content="https://www.languageacademy.com.au/images/logol.png" />
        <meta name="twitter:image:alt" content="LA Language Academy Logo" />
        <meta property="og:url" content="https://www.languageacademy.com.au/refund-policies" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Refund Policy | LA Language Academy Australia" />
        <meta property="og:description" content="Understand LA Language Academy's refund policies for all courses and services. Learn about our transparent and hassle-free refund process." />
        <meta property="og:image" content="https://www.languageacademy.com.au/images/logol.png" />
        <meta property="og:image:alt" content="LA Language Academy Logo" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
      </Helmet>
      <div className="new-design">
        <Header />
            {/* <HeroSectionUpdatedSecond data={heroData} /> */}
             <NocBanner
                      data={heroData}
                      extraClass={"contact-hero-section pte-scoring"}
                      extraClass2={"align-items-start"}
                    />
            <div className="w-100 off-white pt-5">
            <div style={{width:"94%" , marginInline:"auto" , fontFamily: "'Plus Jakarta Sans', sans-serif" }} className="custom-container py-5 ">
             
             <div className="py-4 refund-policy-border">
              <h4 className="fw-600">Overview</h4>
              <p className="FS16FW500">This Refund Policy applies to all products and services offered by Language Academy Australia Pty Ltd ("Language Academy," "we," "us," or "our"), including in-person classes, online live coaching, video courses, and mobile app subscriptions.</p>

              <p className="FS16FW500">Please read this policy carefully before enrolling in any course or purchasing any subscription. By completing payment, you acknowledge that you have read, understood, and agreed to this Refund Policy.</p>
             </div>

             <div className="py-4 refund-policy-border">
              <h4 className="fw-600">No Refunds</h4>
              <p className="FS16FW500 fst-italic fw-bold">All fees paid to Language Academy are strictly non-refundable. No refund will be issued under any circumstances, including change of mind, inability to attend, or change in personal circumstances.</p>

              <p className="FS16FW500 mt-4">This applies to all services, including:</p>
              <ul className="list-disc ps-4 FS16FW500">
                <li className="mb-2">In-person classes at our Parramatta centre</li>
                <li className="mb-2">Online live coaching classes</li>
                <li className="mb-2">Video courses and self-paced learning modules</li>
                <li className="mb-2">Mobile app subscriptions (monthly, two-month, or three-month plans)</li>
              </ul>

              <p className="FS16FW500 mt-4">Once payment has been received and enrolment or subscription access has been granted, the fees for that period are non-refundable regardless of whether you access or use the service.</p>
             </div>

             <div className="py-4 refund-policy-border">
              <h4 className="fw-600">Technical Overcharge Exception</h4>
              <p className="FS16FW500 fst-italic fw-bold">All fees paid to Language Academy are strictly non-refundable. No refund will be issued under any circumstances, including change of mind, inability to attend, or change in personal circumstances.</p>

              <p className="FS16FW500 mt-4">The only circumstance in which a payment adjustment may be considered is where you have been incorrectly charged more than the stated fee due to a verified technical error on our Platform.</p>

              <p className="FS16FW500 mt-4">To request a review of a suspected overcharge:</p>
              <ul className="list-disc ps-4 FS16FW500">
                <li className="mb-2">Contact us at <a href="mailto:info@languageacademy.com.au">info@languageacademy.com.au</a> within 24 hours of the transaction</li>
                <li className="mb-2">Include your full name, account email address, transaction date, amount charged, and a description of the issue</li>
                <li className="mb-2">We will investigate and, if a technical overcharge is confirmed, process a correction to the overcharged amount only</li>
              </ul>

              <p className="FS16FW500 mt-4">Requests submitted after 24 hours of the transaction, or where no technical error can be verified, will not be eligible for any adjustment.</p>
             </div>

             <div className="py-4 refund-policy-border">
              <h4 className="fw-600">Subscription Pause</h4>
              <p className="FS16FW500">While all fees are non-refundable, students with an active subscription may request a pause of up to one (1) month where a valid medical or health reason is provided.</p>

              <p className="FS16FW500 mt-4">To request a pause:</p>
              <ul className="list-disc ps-4 FS16FW500">
                <li className="mb-2">Email us at <a href="mailto:info@languageacademy.com.au">info@languageacademy.com.au</a> with your reason and any supporting documentation (e.g. medical certificate)</li>
                <li className="mb-2">Pause requests must be submitted before the period you wish to pause begins</li>
                <li className="mb-2">Pauses are granted at Language Academy’s sole discretion</li>
              </ul>

              <p className="FS16FW500 mt-4">If approved, your subscription period will be extended by the duration of the approved pause. No cash refund or credit will be issued. A maximum of one pause may be granted per subscription term.</p>
             </div>

             <div className="py-4 refund-policy-border">
              <h4 className="fw-600">Subscription Conversion</h4>
              <p className="FS16FW500">If you wish to move from one subscription plan to another (e.g. Silver to Gold), Language Academy can apply the remaining value of your current subscription as a pro-rata credit toward your new plan.</p>

              <p className="FS16FW500 mt-4">To request a conversion:</p>
              <ul className="list-disc ps-4 FS16FW500">
                <li className="mb-2">Contact us at <a href="mailto:info@languageacademy.com.au">info@languageacademy.com.au</a> specifying your current plan and the plan you wish to switch to</li>
                <li className="mb-2">Conversions are processed manually and subject to Language Academy’s approval</li>
                <li className="mb-2">The credit applied will be calculated based on the unused portion of your current billing cycle at the time of conversion</li>
              </ul>

              <p className="FS16FW500 mt-4">No cash refund will be issued as part of a conversion. The credit applies to the new subscription plan only and has no monetary value outside of the Platform.</p>
             </div>

             <div className="py-4 refund-policy-border">
              <h4 className="fw-600">Chargebacks and Payment Disputes</h4>
              <p className="FS16FW500">If you initiate a chargeback or reverse a payment through your bank or payment provider without first contacting Language Academy, we reserve the right to:</p>

              <ul className="list-disc ps-4 FS16FW500 mt-4">
                <li className="mb-2">Suspend or permanently terminate your account immediately</li>
                <li className="mb-2">Pursue recovery of any costs incurred as a result of the chargeback</li>
              </ul>

              <p className="FS16FW500 mt-4">We strongly encourage you to contact us at <a href="mailto:info@languageacademy.com.au">info@languageacademy.com.au</a> to resolve any billing concerns before initiating a dispute with your bank or payment provider. We are committed to resolving genuine issues promptly and fairly.</p>
             </div>

             <div className="py-4 refund-policy-border">
              <h4 className="fw-600">Australian Consumer Law</h4>
              <p className="FS16FW500">Nothing in this Refund Policy is intended to exclude, restrict, or modify any rights you may have under the Australian Consumer Law (Schedule 2 of the Competition and Consumer Act 2010 (Cth)). To the extent that any provision of this policy is inconsistent with your statutory rights under Australian Consumer Law, your statutory rights will prevail.</p>
             </div>

             <div className="py-4">
               <h4 className="fw-600">Contact Us</h4>
               <p style={{color:"#686868"}} className="FS16FW500">For any questions about this Privacy Policy, please contact us:</p>

               <div className="d-flex flex-wrap mt-4" style={{ gap: "20px 40px" }}>
                 <div style={{ flex: "1 1 220px", minWidth: "220px" }} className="mb-3">
                   <p className="text-secondary FS16FW500 mb-1">Inquiry</p>
                   <p className="FS16FW500 fw-600 text-dark mb-0">
                     <a href={`mailto:${getEmail()}`} className="text-dark text-decoration-underline">{getEmail()}</a>
                   </p>
                 </div>
                 <div style={{ flex: "1 1 220px", minWidth: "220px" }} className="mb-3">
                   <p className="text-secondary FS16FW500 mb-1">Call Us</p>
                   <p className="FS16FW500 fw-600 text-dark mb-0">
                     <a href="tel:+61426230061" className="text-dark text-decoration-none">+61 426 230 061</a>
                   </p>
                 </div>
                 <div style={{ flex: "1 1 220px", minWidth: "220px" }} className="mb-3">
                   <p className="text-secondary FS16FW500 mb-1">Visit Us</p>
                   <p className="FS16FW500 fw-600 text-dark mb-0">{getAddress()}</p>
                 </div>
                 <div style={{ flex: "1 1 220px", minWidth: "220px" }} className="mb-3">
                   <p className="text-secondary FS16FW500 mb-1">Website</p>
                   <p className="FS16FW500 fw-600 text-dark mb-0">
                     <a href="https://www.languageacademy.com.au" target="_blank" rel="noopener noreferrer" className="text-dark text-decoration-underline">https://www.languageacademy.com.au</a>
                   </p>
                 </div>
               </div>
              </div>
            </div>
          </div>        

             <div className="custom-container mt-2" style={{ padding: "40px 0 30px 0" , width:"94%" }}>
                <CtaBanner
                  title="Ready to Test Your "
                  highlight="Level?"
                  buttonText="Book Free Consultation"
                  onClick={() => { const modal = new window.bootstrap.Modal(document.getElementById('staticBackdrop')); modal.show(); }}
                  rightImage="/images/web-new-images/HomePageImage/CTA-Image.webp"
                  btnText="Take Free Mock Test"
                  subTitle={"Take a free mock test and understand your current standing before enrolling."}
                />
              </div>
        <Footer />
      </div>
    </React.Fragment>
  );
};

export default Refund;